<div [ngClass]="klass">
  <span class="class">
    {{ klass }}
  </span>
  <span class="pi">{{ pi }}</span>
</div>
